import cn from 'classnames';
import { IAdminEquipmentGroup } from 'types';
import { StyledAdminEquipmentGroupsListRow } from './styles';
import { AdminListCheckbox } from '../AdminListCheckbox';
import { ReactComponent as LinkIcon } from 'assets/icons/link-icon.svg';
import { AdminListRowCell } from '../AdminListRowCell';

export interface IEquipmentGroupsListRowProps {
  children?: React.ReactNode;
  selected: boolean;
  onSelect: (id: IAdminEquipmentGroup['workerId'], selected: boolean) => void;
  group: IAdminEquipmentGroup;
}

export const equipmentFieldMap: Record<
  string,
  (group: IEquipmentGroupsListRowProps['group']) => React.ReactNode
> = {
  equipmentId: (group) => group.equipmentId,
  link: (group) => (
    <a href={group.link} target="_blank" rel="noopener noreferrer">
      <LinkIcon />
    </a>
  ),
  stringDeviceGroupName: (group) => group.stringDeviceGroupName,
  currentDeviceGroupName: (group) => group.currentDeviceGroupName,
  testHashrate: (group) => group.testHashrate,
  hashRate1hour: (group) => group.hashRate1hour,
  hashRate24h: (group) => group.hashRate24h,
  hashrateWeekly: (group) => group.hashrateWeekly,
};

export const AdminEquipmentGroupsListRow = ({
  group,
  selected,
  onSelect,
}: IEquipmentGroupsListRowProps) => {
  const selectRowHandler = () => {
    onSelect(group.workerId, !selected);
  };

  return (
    <StyledAdminEquipmentGroupsListRow>
      <div className="admin-list-cell-container select">
        <AdminListCheckbox checked={selected} onChange={selectRowHandler} />
      </div>
      {Object.entries(equipmentFieldMap).map(([title, valueGetter]) => (
        <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
          <AdminListRowCell>{valueGetter(group)}</AdminListRowCell>
        </div>
      ))}
    </StyledAdminEquipmentGroupsListRow>
  );
};
